import { render, staticRenderFns } from "./MarketContactInfoCard.vue?vue&type=template&id=0aa93e49"
import script from "./MarketContactInfoCard.vue?vue&type=script&lang=js"
export * from "./MarketContactInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports